// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"095f5510","977":"33efc154"}[chunkId] + ".chunk.js";
};